import { useInfiniteQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";

const getEventTypes = async ({ queryKey, pageParam = 1 }) => {
    const { limit, search } = queryKey;
    const payload = {
      pageNumber: pageParam,
      limit,
      searchTerm: search
    };
  
    const response = await apiClient.post("/api/v1/vision_events/getAll", payload);
  
    if (response.status !== 200) {
      throw new Error("Error fetching eventType data");
    }
  
    return {
      eventTypeData: response.data.eventTypeData,
      currentPage: response.data.currentPage,
      totalPages: response.data.totalPages
    };
  };
  
  export const useEventType = ({ limit = 15, search }) => {
    return useInfiniteQuery({
      queryKey: ["eventType", { limit, search }],
      queryFn: ({ pageParam = 1 }) => getEventTypes({ queryKey: { limit, search }, pageParam }),
      getNextPageParam: (lastPage) => {
        if (lastPage.currentPage < lastPage.totalPages) {
          return lastPage.currentPage + 1;
        }
        return undefined;
      },
      staleTime: 5 * 60 * 1000,
      retry: 1
    });
  };
  